define('app/factories/timers_factory',['app/setup', 'app/models/timer', 'app/views/timer_view','app/views/simple_timer_view'],
  function(takhfifan, timerModel, TimerView, SimpleTimerView) {

    $('.tkh-timer').each(function(){
      var $this = $(this);
      var dealId = $this.data('product-id');
      new takhfifan.TimerView({
        el: $this,
        dealId: dealId,
        model: new takhfifan.Timer({
          dealId: dealId
        })
      });
    });

    $('.tkh-simple-timer').each(function(){
      var $this = $(this);
      new takhfifan.SimpleTimerView({
        el: $this
      });
    });

  });

